module.exports = __webpack_public_path__ + "img/logo.bb6a9f3d.png";